/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from "react";
import Footer from "Components/Footer/Footer";
import Header from "Components/Header/Header";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./ProfilShow.scss";
import ProfilBarShow from "Components/ProfilBar/ProfilBarShow/ProfilBarShow";
import { Divider } from "primereact/divider";
import { useFetchGet } from "Services/api";
import { useParams } from "react-router-dom";
import { formatDate } from "../../../Services/functions";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import axios from "axios";
import { useTranslation } from "react-i18next";
import crown from "assets/crown.png";

/**
 * Permet d'afficher la page de détails du profil d'une personne sélectionnée dans l'annuaire
 * Un utilisateur peut aussi avoir un aperçu de cette page pour son profil via "aperçu du profil" dans /profil
 * Accessible pour tous les utilisateurs
 */
const ProfilShow = (props) => {
  const { id } = useParams();
  const userData = useFetchGet(
      id == props.auth.userConnected.id ? `/users/${id}/private` : `/users/${id}`,
      props.auth.token
  );
  const { t } = useTranslation("common");

  // Fonction de protection pour éviter les erreurs d'affichage d'objets
  const getLabel = (val) => {
    if (!val) return "";
    if (typeof val === "object") return val.label || "";
    return val;
  };

  const downloadRPResume = () => {
    let cvId = userData.data.resume.id;
    if (!cvId) {
      props.auth?.toast?.current?.show({
        severity: "error",
        summary: "Erreur",
        detail: "Cet utilisateur n'a pas de CV",
        life: 5000,
      });
      return;
    }
    let url = `${process.env.REACT_APP_BASE_URL_API}/cvs/${cvId}/pdf`;
    axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${props.auth.token}`,
            accept: "application/json",
          },
          responseType: "blob",
        })
        .then((res) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(res.data);
          let filename =
              res.headers["content-disposition"]?.split("filename=")[1];
          filename = filename?.split(".pdf")[0];
          filename = filename?.replace(/"/g, "");
          link.setAttribute("download", filename || "cv.pdf");
          link.click();
        })
        .catch((error) => {
          props.auth?.toast?.current?.show({
            severity: "error",
            summary: "Erreur",
            detail: error?.response?.data?.detail || "Une erreur est survenue",
            life: 5000,
          });
        });
  };

  return (
      <div className="profil_show">
        <Header>
          <div className="profilPage__headerProfilBar">
            {props.auth.isConnected && userData.loaded && (
                <ProfilBarShow user={userData.data} />
            )}
          </div>
        </Header>
        <div className="profil_show__container">
          {props.auth.isConnected && (
              <>
                {/* === Études & Diplômes === */}
                <div className="profil_show__container__column">
                  <div className="profil_show__container__article">
                    <div className="profil_show__container__article__title">
                      <h1 className="h1_trait_dessus">
                        {t("profilEdition.studiesDegrees.title")}
                      </h1>
                    </div>
                    <div className="profil_show__container__article__container">
                      {userData.loaded &&
                          userData.data.resume &&
                          userData.data.resume.educations
                              ?.sort(
                                  (a, b) =>
                                      new Date(a?.startDate) - new Date(b?.startDate)
                              )
                              ?.sort(
                                  (a, b) =>
                                      new Date(a?.endDate || Date.now()) -
                                      new Date(b?.endDate || Date.now())
                              )
                              ?.sort((a, b) => a?.current - b?.current)
                              ?.map((education) => {
                                if (education?.certified)
                                  return (
                                      <div
                                          className="profil_show__container__article__container__experience"
                                          key={education.id}
                                      >
                                        {education?.obtainedDiplome && (
                                            <img src={crown} alt="certifié" />
                                        )}
                                        <h4>
                                          {education?.current
                                              ? getLabel(education?.currentEtape)
                                              : getLabel(education?.obtainedDiplome)}
                                        </h4>
                                        <p>
                                          {education?.current
                                              ? t(
                                                  "profilEdition.professionalExperiences.inProgress"
                                              )
                                              : education?.startDate
                                                  ? `${new Date(
                                                      education?.startDate
                                                  )?.getFullYear()} - ${new Date(
                                                      education?.endDate
                                                  )?.getFullYear()}`
                                                  : new Date(education?.endDate)?.getFullYear()}
                                        </p>
                                        <div className="profil_show__container__article__container__experience__item">
                                          {education?.obtainedDiplome &&
                                              t(
                                                  "profilEdition.professionalExperiences.certifiedFormation"
                                              )}
                                          <br />
                                          {getLabel(props.auth.universityConnected)}
                                          <br />
                                          {getLabel(education?.domain)}
                                        </div>
                                        <p>
                                          <span>{getLabel(education?.studyLevel)}</span>
                                        </p>
                                        <Divider />
                                      </div>
                                  );
                                else
                                  return (
                                      <div
                                          className="profil_show__container__article__container__experience"
                                          key={education.id}
                                      >
                                        <h4>{getLabel(education.diploma)}</h4>
                                        <p>
                                          {formatDate(education.startDate, "/")} -{" "}
                                          {formatDate(education.endDate, "/")}
                                        </p>
                                        <div className="profil_show__container__article__container__experience__item">
                                          {getLabel(education.school)}
                                          <br />
                                          {getLabel(education.domain)}
                                        </div>
                                        <p>
                                          <span>{getLabel(education.studyLevel)}</span>
                                        </p>
                                        <Divider />
                                      </div>
                                  );
                              })}
                    </div>
                  </div>
                </div>

                {/* === Expériences professionnelles === */}
                <div className="profil_show__container__article">
                  <div className="profil_show__container__article__title">
                    <h1 className="h1_trait_dessus">
                      {t("profilEdition.professionalExperiences.title")}
                    </h1>
                  </div>
                  <div className="profil_show__container__article__container__exp">
                    {userData.loaded &&
                        userData.data.resume &&
                        userData.data.resume.experiences
                            ?.sort(
                                (a, b) => new Date(a?.startDate) - new Date(b?.startDate)
                            )
                            ?.sort(
                                (a, b) =>
                                    new Date(a?.endDate || Date.now()) -
                                    new Date(b?.endDate || Date.now())
                            )
                            ?.sort((a, b) => a?.current - b?.current)
                            .map((xp) => (
                                <div
                                    className="profil_show__container__article__container__exp__experience"
                                    key={xp.id}
                                >
                                  <h4>
                                    {getLabel(xp.company)} - {getLabel(xp.city)}
                                  </h4>
                                  <p>
                                    {formatDate(xp.startDate, "/")} -{" "}
                                    {xp.current
                                        ? t("profilEdition.professionalExperiences.today")
                                        : formatDate(xp.endDate, "/")}
                                  </p>
                                  <div className="profil_show__container__article__container__exp__experience__item">
                                    <h5>
                                      <strong>
                                        {t("profilEdition.professionalExperiences.role")}
                                      </strong>
                                    </h5>
                                    <p>{getLabel(xp.jobname)}</p>
                                  </div>
                                  <div className="profil_show__container__article__container__exp__experience__item">
                                    <h5>
                                      <strong>
                                        {t(
                                            "profilEdition.professionalExperiences.sector"
                                        )}
                                      </strong>
                                      :{" "}
                                    </h5>
                                    <p>{getLabel(xp.sector)}</p>
                                  </div>
                                  <div className="profil_show__container__article__container__exp__experience__item">
                                    <h5>
                                      <strong>
                                        {t(
                                            "profilEdition.professionalExperiences.domain"
                                        )}
                                      </strong>
                                      :{" "}
                                    </h5>
                                    <p>{getLabel(xp.domain)}</p>
                                  </div>
                                  <div className="profil_show__container__article__container__exp__experience__item">
                                    <h5>
                                      <strong>
                                        {t(
                                            "profilEdition.professionalExperiences.category"
                                        )}
                                      </strong>
                                      :{" "}
                                    </h5>
                                    <p>{getLabel(xp.category)}</p>
                                  </div>
                                  {xp.description && (
                                      <div className="profil_show__container__article__container__exp__experience__item">
                                        <h5>
                                          <strong>
                                            {t("profilEdition.personalInfo.description")}
                                          </strong>
                                          :{" "}
                                        </h5>
                                        <p>{xp.description}</p>
                                      </div>
                                  )}
                                  <Divider />
                                </div>
                            ))}
                  </div>
                </div>

                {/* === Compétences === */}
                <div className="profil_show__container__article mobile">
                  <div className="profil_show__container__article__title">
                    <h1 className="h1_trait_dessus">
                      {t("profilEdition.skills.title")}
                    </h1>
                  </div>
                  <div className="profil_show__container__article__container__competences">
                    {userData.loaded &&
                        userData.data.resume &&
                        userData.data.resume.skills.map((item) => (
                            <div className="competence" key={item.id}>
                              <h4>{getLabel(item.skill)}</h4>
                            </div>
                        ))}
                  </div>
                </div>

                <div className="profil_show__container__article desktop">
                  <div className="profil_show__container__article__title">
                    <h1 className="h1_trait_dessus">
                      {t("profilEdition.skills.title")}
                    </h1>
                  </div>
                  <div className="profil_show__container__article__container__competences">
                    {userData.loaded &&
                        userData.data.resume &&
                        userData.data.resume.skills.map((item) => (
                            <div className="competence" key={item.id}>
                              <h4>{getLabel(item.skill)}</h4>
                            </div>
                        ))}
                  </div>
                </div>
              </>
          )}
        </div>

        {userData.loaded && userData.data.resume && (
            <BtnBleu btnAction={downloadRPResume}>
              {t("profilShow.download")}
            </BtnBleu>
        )}
        <Footer />
      </div>
  );
};

ProfilShow.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProfilShow);
